import React, { useState } from "react";
import { useAdminPanelContext } from "../../context/AdminPanelContext";
import { ScraperConfig } from "./types";
import ConfigPanelList, { ConfigPanelListProps } from "./ConfigPanelList";
import GenericPanelToggle, {
	PanelProps,
	PanelType,
} from "../GenericPanelToggle";

interface ConfigPanelProps {
	configs: ScraperConfig[];
}

const ConfigPanel: React.FC<ConfigPanelProps> = ({ configs }) => {
	const { handleConfigs } = useAdminPanelContext();
	const [lastUnsavedId, setLastUnsavedId] = useState(0);

	const handleAddNewConfig = () => {
		const newUnsavedId = lastUnsavedId - 1;
		const unsavedConfig: ScraperConfig = {
			id: newUnsavedId,
			name: "New config" + -newUnsavedId,
			active: false,
			scraperConfigOptions: [],
		};
		handleConfigs.add(unsavedConfig, false);
		setLastUnsavedId(newUnsavedId);
	};

	return (
		<GenericPanelToggle
			items={configs}
			panelType={PanelType.SCRAPER_CONFIG}
			handleAddNew={handleAddNewConfig}
			RenderForm={(props: PanelProps) => {
				return <ConfigPanelList {...(props as ConfigPanelListProps)} />;
			}}
		/>
	);
};

export default ConfigPanel;
